import { AccountType } from '@ariksa/cloud-account';
import { CloudProviders, RepositoryService } from '@ariksa/cloud-account';
import { ComplianceStandards } from '@ariksa/compliance-policies';
import { CloudEnvironmentType } from '@ariksa/compliance-policies/api';
import { SupportedServices } from '@ariksa/data-scanning';
import {
  ContextType,
  Categories,
  NativeResources,
  Resources,
} from '@ariksa/inventory-core';
import { Clients } from '@ariksa/notification';
import { ReportTypes } from '@ariksa/reporting';
import { ApplicationEnum } from 'services/Vulnerability/types';

export const CustomIconTypes = {
  AccessKeys: 'AccessKeys',
  Api: 'Api',
  LeakedCredential: 'LeakedCredential',
  Libraries: 'Libraries',
  Library: 'Library',
  BlockPublicAcls: 'Block public acls',
  BlockPublicAcl: 'Block public acl',
  BlockPublicPolicy: 'Block public policy',
  IgnorePublicAcls: 'Ignore public acls',
  RestrictPublicBuckets: 'Restrict public buckets',
  DataProtection: 'Data protection',
  ObjectOwnership: 'Object ownership',
  Endpoint: 'Endpoint',
  Access: 'Access',
  Route53TrafficPolicy: 'Route53TrafficPolicy',
  Route53RecordSet: 'Route53RecordSet',
  SNSSubscription: 'SNSSubscription',
  SNSTopic: 'SNSTopic',
  Sagemaker: 'Sagemaker',
  ECSTask: 'ECSTask',
  EcsInstance: 'EcsInstance',
  RdsInstance: 'RdsInstance',
  RedshiftInstance: 'RedshiftInstance',
  AriksaOutpost: 'Ariksa Outpost',
  NoSql: 'NoSQL',
  DebianLinux: 'Debian GNU/Linux',
  Debian: 'Debian',
  debian: 'debian',
  RedHatEnterpriseLinux: 'Red Hat Enterprise Linux',
  RedHatEnterpriseLinuxServer: 'Red Hat Enterprise Linux Server',
  RedHat: 'Red Hat',
  Ubuntu: 'Ubuntu',
  Windows: 'Windows',
  windows11: 'windows-11',
  Region: 'Region',
  Vmware: 'vmware',
  AmazonLinux: 'Amazon Linux',
  Python: 'Python',
  ExclamationTriangle: 'ExclamationTriangle',
  ExclamationCircle: 'ExclamationCircle',
  Suppress: 'Suppress',
  SuppressAlarm: 'SuppressAlarm',
  Blueprint: 'Blueprint',
  BlueprintView: 'BlueprintView',
  Egress: 'Egress',
  Ingress: 'Ingress',
  Pii: 'Pii',
  EventLog: 'EventLog',
  CloudService: 'CloudService',
  Permission: 'Permission',
  Internet: 'Internet',
  Resource: 'Resource',
  Crown: 'Crown',
  Technology: 'Technology',
  OperatingSystem: 'OS',
  Ami: 'Ami',
  Packages: 'Packages',
  Distribution: 'Distribution',
  Environment: 'Environment',
  Notification: 'Notification',
  DataScan: 'DataScan',
  Vulnerability: 'Vulnerability',
  TrustedEntities: 'TrustedEntities',
  CloudInventory: 'Cloud Inventory',
  ContainerVolume: 'ContainerVolume',
  ContainerRepository: 'ContainerRepository',
  ContainerVulnerability: 'ContainerVulnerability',
  SeverityCritical: 'SeverityCritical',
  SeverityMedium: 'SeverityMedium',
  SeverityLow: 'SeverityLow',
  NetworkMap: 'NetworkMap',
  EcrImage: 'ECRImage',
  ResourceType: 'Resource Type',
  AuthGraph: 'AuthGraph',
  IndividualAlerts: 'IndividualAlerts',
  Evidence: 'Evidence',
  ZoomIn: 'ZoomIn',
  ZoomOut: 'ZoomOut',
  VpcGateway: 'VpcGateway',
  CloudActivity: 'CloudActivity',
  Interface: 'Interface',
  Alert: 'Alert',
  Route: 'Route',
  CommandLine: 'CommandLine',
  BlueprintException: 'BlueprintException',
  Download: 'Download',
  LateralMovement: 'LateralMovement',
  Login: 'Login',
  Logout: 'Logout',
  PrefixList: 'PrefixList',
  PrincipalAccess: 'PrincipalAccess',
  TrustedEntity: 'TrustedEntity',
  ViewAll: 'ViewAll',
  Clock: 'Clock',
  Label: 'Label',
  Tag: 'Tag',
  Hacker: 'Hacker',
  QuestionMark: 'QuestionMark',
  Context: 'Context',
  ContextLabel: 'ContextLabel',
  Console: 'Console',
  Whitelist: 'Whitelist',
  Metadata: 'Metadata',
  Exception: 'Exception',
  Checklist: 'Checklist',
  Dependencies: 'Dependencies',
  BarChart: 'BarChart',
  LineChart: 'LineChart',
  Sms: 'Sms',
  Sso: 'Sso',
  Ticket: 'Ticket',
  AzureActiveDirectory: 'AzureActiveDirectory',
  DataSources: 'DataSources',
  IdentityAndAccess: 'Identity & Access',
  Search: 'Search',
  Remediate: 'Remediate',
  Details: 'Details',
  Timeline: 'Timeline',
  Disable: 'Disable',
  VirtualMachines: 'Virtual Machines',
  DataClassification: 'DataClassification',
  AriksaBestPractices: 'Ariksa Best Practices',
  ISO27001: 'ISO 27001',
  ISO27001_2022: 'ISO 27001:2022',
  ISO27701_2019: 'ISO 27701:2019',
  ISO27701: 'ISO 27701',
  ISO_27701: 'ISO_27701',
  AriksaLogo: 'AriksaLogo',
  AriksaLogoOnly: 'AriksaLogoOnly',
  CloudChart: 'CloudChart',
  RegexDataClassifier: 'RegexDataClassifier',
  Remove: 'Remove',
  ComplianceEnforcedChecks: 'ComplianceEnforcedChecks',
  CompliancePassedChecks: 'CompliancePassedChecks',
  ComplianceFailedChecks: 'ComplianceFailedChecks',
  ComplianceCheckExceptions: 'ComplianceCheckExceptions',
  ComplianceResource: 'ComplianceResource',
  HistoricalTimeline: 'HistoricalTimeline',
  IdentityAndAccessManagement: 'Identity and Access Management',
  DataRecovery: 'Data Recovery',
  'SimpleStorageService(S3)': 'Simple Storage Service (S3)',
  'Relational Database Service (RDS)': 'Relational Database Service (RDS)',
  Networking: 'Networking',
  AWSWhite: 'AWSWhite',
  Home: 'Home',
  Registry: 'Registry',
  Cve: 'cve',
  ContainersOnVirtualMachine: 'ContainersOnVirtualMachine',
  azuread: 'azuread',
  Automation: 'Automation',
  Workflow: 'Workflow',
  List: 'List',
  Summary: 'Summary',
  Overview: 'Overview',
  CloudPosture: 'Cloud Posture',
  DataSecurity: 'Data Security',
  IdentityAuthorization: 'Identity Authorization',
  UserCanAccess: 'UserCanAccess',
  BurgerMenu: 'BurgerMenu',
  DataTypes: 'DataTypes',
  ADDRESS: 'ADDRESS',
  ARIKSA_EMAIL: 'ARIKSA_EMAIL',
  GMAIL_EMAIL: 'GMAIL_EMAIL',
  EMAIL_ADDRESS: 'EMAIL_ADDRESS',
  PHONE_NUMBER: 'PHONE_NUMBER',
  IP_ADDRESS: 'IP_ADDRESS',
  PERSON: 'PERSON',
  NRP: 'NRP',
  INSURANCE_INFORMATION: 'INSURANCE_INFORMATION',
  MEDICAL_LICENSE: 'MEDICAL_LICENSE',
  UK_NHS: 'UK_NHS',
  IN_AADHAR: 'IN_AADHAR',
  IN_PAN: 'IN_PAN',
  US_DRIVER_LICENSE: 'US_DRIVER_LICENSE',
  US_ITIN: 'US_ITIN',
  US_PASSPORT: 'US_PASSPORT',
  US_SSN: 'US_SSN',
  CREDIT_CARD: 'CREDIT_CARD',
  CRYPTO: 'CRYPTO',
  IBAN_CODE: 'IBAN_CODE',
  US_BANK_NUMBER: 'US_BANK_NUMBER',
  AUTH0_CREDENTIALS: 'AUTH0_CREDENTIALS',
  AWS_ACCESS_KEY: 'AWS_ACCESS_KEY',
  AWS_SECRET_ID: 'AWS_SECRET_ID',
  AZURE_CREDENTIALS: 'AZURE_CREDENTIALS',
  CELERY_CREDENTIALS: 'CELERY_CREDENTIALS',
  CREDENTIALS: 'CREDENTIALS',
  GCP_CREDENTIALS: 'GCP_CREDENTIALS',
  OPEN_AI_KEYS: 'OPEN_AI_KEYS',
  PRIVATE_CREDENTIALS: 'PRIVATE_CREDENTIALS',
  SECRETS: 'SECRETS',
  SENDGRID_CREDENTIALS: 'SENDGRID_CREDENTIALS',
  SSH_KEYS: 'SSH_KEYS',
  STRIPE_CREDENTIALS: 'STRIPE_CREDENTIALS',
  TWILIO_CREDENTIALS: 'TWILIO_CREDENTIALS',
  DataCloud: 'DataCloud',
  IdentityCloud: 'IdentityCloud',
  Route53SubDomain: 'Route53SubDomain',
  Snooze: 'Snooze',
  Service: 'Service',
  SIEM: 'SIEM',
  Rules: 'Rules',
  Attach: 'Attach',
  Detach: 'Detach',
  RepoBranch: 'RepoBranch',
  Copy: 'Copy',
  Pod: 'Pod',
  Namespace: 'Namespace',
  Cloud: 'Cloud',
  Process: 'Process',
  OpenAI: 'OpenAI',
  CloudSlash: 'CloudSlash',
  CacheBehaviour: 'CacheBehaviour',
  OriginConfigurations: 'OriginConfigurations',
  EnforcedPolicies: 'EnforcedPolicies',
  PolicyResourceException: 'PolicyResourceException',
  PolicyException: 'PolicyException',
  OutpostForVulnerability: 'OutpostForVulnerability',
  AllFindings: 'AllFindings',
  Dashboard: 'Dashboard',
  DashboardCategory: 'DashboardCategory',
  DashboardAll: 'DashboardAll',
  DashboardOverview: 'DashboardOverview',
  DatabaseSecurity: 'DatabaseSecurity',
  DATA_AT_RISK: 'DATA_AT_RISK',
  DATA_ENCRYPTION: 'DATA_ENCRYPTION',
  NETWORK_MISCONFIGURATION: 'NETWORK_MISCONFIGURATION',
  DATA_RECOVERY: 'DATA_RECOVERY',
  POOR_GOVERNANCE: 'POOR_GOVERNANCE',
  INSECURE_CREDENTIALS: 'INSECURE_CREDENTIALS',
  INTERNET_EXPOSURE: 'INTERNET_EXPOSURE',
  EXCESS_PERMISSIONS: 'EXCESS_PERMISSIONS',
  UNUSED_ENTITIES: 'UNUSED_ENTITIES',
  PRIVILEGE_ESCALATION: 'PRIVILEGE_ESCALATION',
  ANOMALOUS_ACTIVITY: 'ANOMALOUS_ACTIVITY',
  SEPARATION_OF_DUTIES: 'SEPARATION_OF_DUTIES',
  VULNERABILITIES: 'VULNERABILITIES',
  POOR_AUDITABILITY: 'POOR_AUDITABILITY',
  Comment: 'Comment',
  CheckmarkCircle: 'CheckmarkCircle',
  ThirdParty: 'ThirdParty',
  NewFinding: 'NewFinding',
  ContainerImages: 'ContainerImages',
  ContainerImage: 'Container Image',
  MachineImage: 'Machine Image',
  AnomalousBehaviour: 'Anomalous Behaviour',
  Health: 'Health',
  PII: 'PII',
  PHI: 'PHI',
  PCI: 'PCI',
  SENSITIVE: 'SENSITIVE',
  Sensitive: 'Sensitive',
  SensitiveRecords: 'SensitiveRecords',
  AWS: 'AWS',
  GCP: 'GCP',
  Okta: 'Okta',
  Snowflake: 'Snowflake',
  GitLab: 'GitLab',
  GitHub: 'GitHub',
  BitBucket: 'BitBucket',
  Port: 'Port',
  Printer: 'Printer',
  Globe: 'Globe',
  LockOpen: 'LockOpen',
  GraphIncrease: 'GraphIncrease',
  GraphDecrease: 'GraphDecrease',
  CloseCircle: 'CloseCircle',
  Actions: 'Actions',
  Action: 'Action',
  LearnMore: 'LearnMore',
  BucketDeny: 'BucketDeny',
  Calendar: 'Calendar',
  Chat: 'Chat',
  DoubleTap: 'DoubleTap',
  Exclude: 'Exclude',
  Images: 'Images',
  VMImages: 'VMImages',
  Share: 'Share',
  ThirdPartyIntegration: 'ThirdPartyIntegration',
  ListOfInstances: 'List of instances',
  Jit: 'JIT',
  View: 'View',
  SyncRestart: 'SyncRestart',
  SyncPause: 'SyncPause',
  Severity: 'Severity',
  Informational: 'Informational',
  'Abnormal Behavior': 'Abnormal Behavior',
  'Elevated Risk': 'Elevated Risk',
  'Malicious Behavior': 'Malicious Behavior',
  'Malicious Access': 'Malicious Access',
  Malicious: 'Malicious',
  Vulnerabilities: 'Vulnerabilities',
  EOL: 'EOL',
  Centos: 'Centos',
  CentOS: 'CentOS',
  CentOSLinux: 'CentOS Linux',
  AlpineLinux: 'Alpine Linux',
  PublicIPs: 'Public IPs',
  PublicSubnets: 'Public Subnets',
  AnomalousTraffic: 'Anomalous Traffic',
  AnomalousDataSources: 'Anomalous Data Sources',
  VMsWithSSHOpen: 'VMs with SSH Open',
  PublicVMsWithSSHOpen: 'Public VMs with SSH Open',
  ExternallyAccessiblePublicIps: 'Externally Accessible Public IPs',
  ExternallyAccessibleCompute: 'Externally Accessible Compute',
  GoogleDrive: 'Google Drive',
  Google: 'Google',
  MicrosoftOneDrive: 'Microsoft OneDrive',
  Box: 'Box',
  Kubernetes: 'Kubernetes',
  Dropbox: 'Dropbox',
  Documents: 'Documents',
  ServiceTicket: 'ServiceTicket',
  CISv8: 'CIS v8',
  SOC2: 'SOC 2',
  CISAWS15: 'CIS AWS 1.5',
  CISAWS14: 'CIS AWS 1.4',
  CISEKS15: 'CIS EKS 1 5',
  CISGCPv3: 'CIS GCP 3.0.0',
  CISGCPv4: 'CIS GCP 4.0.0',
  ExposedCredentials: 'Exposed credentials',
  Repository: 'Repository',
  AIML: 'AIML',
  ThreeDots: 'ThreeDots',
  MixedChart: 'MixedChart',
  Issues: 'Issues',
  BusinessCritical: 'BusinessCritical',
  CSV: 'CSV',
  AddOrCreate: 'AddOrCreate',
  ExportToSIEM: 'Export to SIEM',
  Security: 'Security',
  None: 'None',
  JIT: 'JIT',
  At: 'At',
  Link: 'Link',
  TLSv12: 'TLSv1.2',
  TLSv11: 'TLSv1.1',
  TLSv1: 'TLSv1',
  SSLv3: 'SSLv3',
  AllowAll: 'allow-all',
  HttpOnly: 'http-only',
  HttpsOnly: 'https-only',
  MatchViewer: 'match-viewer',
  RedirectToHttps: 'redirect-to-https',
  CloudLakeFormation: 'CloudLakeFormation',
  Serverless: 'Serverless',
  ThumbsUp: 'ThumbsUp',
  ThumbsDown: 'ThumbsDown',
  Running: 'running',
  Stopped: 'stopped',
  Queue: 'Queue',
  ScanningQueue: 'ScanningQueue',
  Patch: 'Patch',
  ArrowUp: 'ArrowUp',
  ArrowDown: 'ArrowDown',
  Minus: 'Minus',
  FilterAdd: 'FilterAdd',
  AzureEntraConnect: 'AzureEntraConnect',
  Play: 'Play',
  Pause: 'Pause',
  Bot: 'Bot',
  SnowflakeSubscription: 'SnowflakeSubscription',
  SuddenActivity: 'SuddenActivity',
  S3Folder: 'S3Folder',
  DataGroup: 'DataGroup',
  PolicyScroll: 'PolicyScroll',
  Hide: 'Hide',
  Mask: 'Mask',
  Fullscreen: 'Fullscreen',
  ExitFullscreen: 'ExitFullscreen',
  Infinity: 'Infinity',
};

export const IconTypes = {
  ...NativeResources,
  ...Resources,
  ...CustomIconTypes,
  ...Clients,
  ...Categories,
  ...ComplianceStandards,
  ...CloudProviders,
  ...SupportedServices,
  ...ContextType,
  ...ApplicationEnum,
  ...AccountType,
  ...RepositoryService,
  ...ReportTypes,
  ...CloudEnvironmentType,
};

export type AriksaIconMap = {
  [key in keyof typeof IconTypes | string]?: any;
};

export type IconType = typeof IconTypes | string;

export type IconSize =
  | 'regular'
  | 'medium'
  | 'large'
  | 'small'
  | 'xs'
  | 'sm'
  | 'md'
  | 'lg'
  | '9';
